import { Injectable } from '@angular/core';
import { EmptyInterceptStrategy } from './auth-shared/EmptyInterceptStrategy';
import { InterceptStrategy } from './auth-shared/InterceptStrategy';
import { MaestrosSyncInterceptStrategy } from './auth-shared/MaestrosSyncInterceptStrategy';
import { SumaxErpInterceptStrategy } from './auth-shared/SumaxErpInterceptStrategy';
import { HttpRequest } from '@angular/common/http';
import { DmsInterceptStrategy } from './auth-shared/DmsInterceptStrategy';

@Injectable({ providedIn: 'root' })
export class InterceptorsStrategyService {

	strategies: InterceptStrategy[] = [
		this.dmsInterceptStrategy,
		this.emptyInterceptStrategy,
		this.maestrosInterceptStrategy,
		this.sumaxErpInterceptStrategy,
	];

	constructor(
		private dmsInterceptStrategy: DmsInterceptStrategy,
		private emptyInterceptStrategy: EmptyInterceptStrategy,
		private maestrosInterceptStrategy: MaestrosSyncInterceptStrategy,
		private sumaxErpInterceptStrategy: SumaxErpInterceptStrategy
	) { }

	resolveStrategy(req: HttpRequest<any>): InterceptStrategy | undefined {
		return this.strategies.find((s) => s.isIntercepted(req));
	}
}

